import serverCode from '../../serverCode'

const defaultState = () => ({
  items: [],
  paged: 0,
  length: 0,
})

const state = defaultState()

const mutations = {
  incrementPage(state) {
    state.paged++
  },
  setItems(state, payload) {
    state.length = payload.length
    state.items = state.items.concat(payload)
  },
  init(state) {
    Object.assign(state, defaultState())
  },
  resetItems(state) {
    Object.assign(state, defaultState())
  },
}

const actions = {
  async getItems({ state, commit, rootState }, { perPage }) {
    try {
      const { succeed, events } = await serverCode(
        'getReservingEvents',
        {
          offset: state.paged * perPage,
          perPage,
        },
        rootState.locale
      )
      if (!succeed) {
        throw new Error()
      } else {
        commit('setItems', events)
      }
    } catch (error) {
      //
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
